<template>
  <div class="pointsList">
    <div class="pointsList-background"></div>
    <div class="pointsList-wrapper">
      <div class="amount-header">
        <div class="amount-label">{{ $t.information.pointsTitle }}</div>
        <div class="amount-value">
          {{ availablePoints }}
        </div>
      </div>
      <van-list
        class="list"
        v-model="loading"
        :finished="finished"
        :finished-text="$t.meta.noMore"
        :error.sync="error"
        :error-text="errorText"
        @load="getList(page + 1)"
      >
        <div class="list-header">{{ $t.information.pointsSubTitle }}</div>
        <div class="detail" v-for="(detail, index) in tableData" :key="index">
          <div class="logo">
            <div
              class="circle"
              :style="{
                background:
                  detail.ChangeType == 1 || detail.ChangeType == 3
                    ? '#65cc3b'
                    : '#ff7a26',
              }"
            ></div>
          </div>
          <div class="left">
            <div class="changeType">
              <span v-if="detail.ChangeType == 1">{{ $t.information.changeType1 }}</span>
              <span v-if="detail.ChangeType == 2">{{ $t.information.changeType2 }}</span>
              <span v-if="detail.ChangeType == 3">{{ $t.information.changeType3 }}</span>
              <span v-if="detail.ChangeType == 4">{{ $t.information.changeType4 }}</span>
            </div>
            <div class="changeDate">{{ detail.CreateTime }}</div>
          </div>
          <div class="right">
            <div
              :class="[
                'points',
                detail.ChangeType == 1 || detail.ChangeType == 3 ? 'green' : 'orange',
              ]"
            >
              <span v-if="detail.ChangeType == 1 || detail.ChangeType == 3">+</span>
              <span>{{ detail.Points }}</span>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { List } from "vant";

Vue.use(List);

export default {
  name: "pointsList",
  data() {
    return {
      availablePoints: 0,
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
    };
  },
  methods: {
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
      };
      return new Promise((resolve) => {
        this.$api.user
          .getCustomerPointChangeRecordListByPage(param)
          .then((res) => {
            this.availablePoints = res.data.AvailablePoints;
            var detail = res.data.PointChangeList;
            this.tableData = this.tableData.concat(detail.Data);
            this.loading = false;
            this.error = false;
            this.errorText = "";

            this.page = detail.PageIndexs;
            this.finished = this.page >= detail.ALLPages;
            resolve(true);
          })
          .catch((error) => {
            this.loading = false;
            this.error = true;
            this.errorText = error.message;
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.pointsList {
  .pointsList-background {
    height: 26.7vw;
    width: 100%;
    background: linear-gradient(left, #132660, #2750aa);
    z-index: -1;
  }
  .pointsList-wrapper {
    margin: -16.7vw auto;
    width: 90%;
    background: #fefefe;
    border-radius: 10px;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.5);
    .amount-header {
      padding: 15px;
      font-size: 14px;
      border-bottom: 1px solid #e5e5e5;
      .amount-label {
        color: #000;
        font-size: 14px;
        font-weight: bold;
      }
      .amount-value {
        color: #ff7a26;
        margin-top: 10px;
        font-size: 25px;
        font-weight: bold;
      }
    }
    .list {
      .list-header {
        font-size: 14px;
        padding: 10px;
        border-bottom: 1px solid #e5e5e5;
      }
      .detail {
        padding: 15px 0px 15px 0px;
        border-bottom: 1px solid #e5e5e5;
        .logo {
          vertical-align: middle;
          display: inline-block;
          width: 25%;
          .circle {
            width: 45px;
            height: 45px;
            margin: auto;
            border-radius: 100px;
          }
        }
        .left {
          vertical-align: middle;
          display: inline-block;
          width: 55%;
          .changeType {
            color: #000;
            font-size: 14px;
            margin-bottom: 5px;
          }
          .changeDate {
            color: #999;
            font-size: 12px;
          }
        }
        .right {
          text-align: center;
          vertical-align: middle;
          display: inline-block;
          width: 20%;
          .points {
            font-size: 14px;
            font-weight: bold;
          }
          .green {
            color: #65cc3b;
          }
          .orange {
            color: #ff7a26;
          }
        }
      }
    }
  }
}
</style>
